import { sendGet } from './../helpers/axios';

export const getInforUser = () => sendGet('/api/user/auth');
